<template>
    <span class="ds-input-wrap">
        <ds-icon v-if="icon" :name="icon" :size="18" :filled="false" color="var(--text-muted)" class="ds-input-icon" />
        <input
            class="ds-input"
            :class="{ 'ds-input--icon': !!icon, 'ds-input--invalid': invalid }"
            :type="type"
            :min="min"
            :max="max"
            :step="step"
            :placeholder="placeholder"
            :value="value"
            :disabled="disabled"
            @input="$emit('change', $event)"
            @focus="focus = true"
            @blur="focus = false"
        />
    </span>
</template>

<script>
export default {
    name: 'DsInput',
    data: () => ({ focus: false }),
    props: {
        icon: { type: String, default: null },
        invalid: { type: Boolean, default: false },
        type: { type: String, default: 'text' },
        min: { type: [Number, String], default: null },
        max: { type: [Number, String], default: null },
        step: { type: [Number, String], default: null },
        placeholder: { type: String, default: null },
        value: { type: [String, Number], default: '' },
        disabled: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.ds-input-wrap { position: relative; display: block; }
.ds-input-icon { position: absolute; left: 10px; top: 9px; pointer-events: none; }
.ds-input {
    width: 100%;
    height: var(--control-height);
    padding: 0 var(--space-3);
    font: var(--type-body);
    color: var(--text-body);
    background: var(--surface-card);
    border: var(--border-width) solid var(--border-field);
    border-radius: var(--radius-sm);
    outline: none;
    transition: var(--transition-control);
    box-sizing: border-box;
}
.ds-input:focus { border-color: var(--brand-blue); box-shadow: var(--shadow-focus); }
.ds-input--invalid { border-color: var(--danger); }
.ds-input--icon { padding-left: 34px; }
</style>
